import React from 'react';
import MLTools from '../components/ml/MLTools';

const MLDemo: React.FC = () => {
  return <MLTools />;
};

export default MLDemo; 